import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  get,
  noop,
} from 'lodash';
import { Element } from 'react-scroll';
import { compose, setDisplayName } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import Collapse from '@material-ui/core/Collapse';
// import Typography from '@material-ui/core/Typography';

import immutableToJS from 'helpers/immutableToJS';
import { scrollTo } from 'helpers/utils';
import {
  HighlightText,
  injectIntl,
} from 'components';
import CardCover from 'components/Card/CardCover';
import CardLogo from 'components/Card/CardLogo';

const styles = () => ({
  cardAction: {
    borderRadius: '50% !important;',
    boxShadow: '0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12) !important;',
    marginTop: 0,
  },
  cardHeader: { width: '100%' },
  cardMedia: { position: 'relative' },
});

class ProfileCard extends Component {
  static contextTypes = {
    isRestaurant: PropTypes.bool,
    isConsumer: PropTypes.bool,
  };

  static propTypes = {
    // bio: PropTypes.string,
    children: PropTypes.node.isRequired,
    classes: PropTypes.shape({}).isRequired,
    details: PropTypes.shape({}).isRequired,
    expanded: PropTypes.bool,
    imageEditable: PropTypes.bool,
    index: PropTypes.number.isRequired,
    initialExpand: PropTypes.bool,
    searchText: PropTypes.string,

    setExpanded: PropTypes.func,
  };

  static defaultProps = {
    // bio: '',
    expanded: false,
    imageEditable: false,
    initialExpand: false,
    searchText: '',
    setExpanded: noop,
  };

  state = {
    // showExtraBio: false,
  };

  componentWillMount() {
    const { initialExpand } = this.props;
    if (initialExpand) this.handleExpandChange(true);
  }

  handleExpandChange = () => {
    const expanded = !this.props.expanded;
    const { details, index, setExpanded } = this.props;
    setExpanded(expanded ? details.accountId : -1, () => {
      if (!expanded) return;
      setTimeout(() => scrollTo(`store-${index}`), 500);
    });
  };

  handleShowExtraBio = () => {
    this.setState(state => ({ showExtraBio: !state.showExtraBio }));
  };

  render() {
    const { isConsumer } = this.context;
    const {
      // bio,
      children,
      classes,
      details,
      expanded,
      imageEditable,
      searchText,
    } = this.props;
    // const { showExtraBio } = this.state;
    const currentLogoUrl = get(details, 'account.profile.logoUrl');
    const currentCoverImageUrl = get(details, 'account.profile.coverImageUrl');
    const subTitle = (
      <div className="sub-title">
        <div className="email">
          <HighlightText
            highlight={searchText}
            text={details.account.email || ''}
          />
        </div>
      </div>
    );
    const avatar = (
      <CardLogo
        image={currentLogoUrl}
        imageEditable={imageEditable}
        info={details.account.profile}
      />
    );
    // const bioContent = (
    //   <Typography component="p" className="bio-cotent">
    //     {bio}
    //   </Typography>
    // );
    // const bioComponent = bio ? (
    //   bio.length > 500 ? (
    //     <Collapse
    //       collapsedHeight="50px"
    //       in={showExtraBio}
    //     >
    //       {bioContent}
    //     </Collapse>
    //   ) : (bioContent)
    // ) : '';
    const cardCover = currentCoverImageUrl ? (
      <CardMedia
        classes={{ root: classes.cardMedia }}
        image={currentCoverImageUrl}
      >
        <CardCover
          image={currentCoverImageUrl}
          imageEditable={imageEditable}
          info={details.account}
        />
      </CardMedia>
    ) : (
      <CardCover
        image={currentCoverImageUrl}
        imageEditable={imageEditable}
        info={details.account}
      />
    );
    return (
      <Element className={`profile-card ${isConsumer ? 'no-border-table' : ''}`} style={{ padding: '5px 0' }}>
        <Card>
          <CardHeader
            avatar={avatar}
            classes={{
              action: classes.cardAction,
              content: classes.cardHeader,
            }}
            title={
              <div
                style={{
                  position: 'relative',
                  display: 'flex',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                  justifyContent: 'space-between',
                }}
              >
                <div>
                  <HighlightText
                    highlight={searchText}
                    text={details.account.profile.companyName}
                  />
                  { !isConsumer && 
                    <HighlightText
                      highlight={searchText}
                      style={{
                        color: 'gray',
                        fontSize: 12,
                        marginLeft: 10,
                      }}
                      text={`${details.account.profile.firstName || ''} ${details.account.profile.lastName || ''}`}
                    />
                  }
                  {subTitle}
                </div>
              </div>
            }
          />
          <Collapse
            in={expanded}
            timeout="auto"
            unmountOnExit
          >
            {!isConsumer && cardCover}
            {/* <CardContent>
              <div className="bio-collapse">
                {bioComponent}
                {
                  bio.length > 500 && (
                    <IconButton
                      aria-expanded={showExtraBio}
                      aria-label="Show more"
                      onClick={this.handleShowExtraBio}
                    >
                      {showExtraBio ? <CollapseIcon /> : <ExpandIcon />}
                    </IconButton>
                  )
                }
              </div>
            </CardContent> */}
            <CardContent>
              {children}
            </CardContent>
          </Collapse>
        </Card>
      </Element>
    );
  }
}

export default compose(
  setDisplayName('ProfileCard'),
  withStyles(styles),
  immutableToJS,
  injectIntl,
)(ProfileCard);
